import React from 'react';

export default function Breadcrumbs({ items, navigateTo }) {
    return (
        <nav className="flex text-sm text-gray-500 mb-6 overflow-x-auto whitespace-nowrap pb-2">
            <ol className="flex items-center space-x-2">
                <li>
                    <a href="#home" onClick={(e) => { e.preventDefault(); navigateTo('home'); }} className="hover:text-pink-500 transition-colors">Home</a>
                </li>
                {items.map((item, index) => (
                    <li key={index} className="flex items-center space-x-2">
                        <span className="text-gray-300">/</span>
                        {item.action ? (
                            <button onClick={item.action} className="hover:text-pink-500 transition-colors">
                                {item.label}
                            </button>
                        ) : (
                            <span className={index === items.length - 1 ? "font-semibold text-gray-800" : "hover:text-pink-500"}>
                                {item.label}
                            </span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
}